// import { Box, Grid } from "@mui/material";
// import React from "react";
// import { Controller } from "react-hook-form";
// import { styles } from "../components/formStyles";
// import FormInput from "./commonForm";
// const ReusableFormFields = ({
//   inputFields,
//   control,
//   errors,
//   register,
//   setValue,
//   required = false,
//   defaultSize = "small",
//   onFieldClick,
//   onFieldFocus,
//   onFieldBlur,
// }) => {
//   return (
//     <>
//       {inputFields.map((field) => {
//         if (field.type === "group") {
//           return (
//             <Box
//               sx={{
//                 ...styles.textFieldContainer,
//                 width: field.width || "100%",
//                 display: field.display !== false ? "block" : "none",
//               }}
//               key={field.name}
//             >
//               <Grid
//                 container
//                 spacing={2}
//                 sx={{ display: "flex", alignItems: "center" }}
//               >
//                 {field.fields.map((subField) => (
//                   <Grid item xs={6} key={subField.name}>
//                     <Controller
//                       name={subField.name}
//                       control={control}
//                       render={({ field: controllerField }) => (
//                         <FormInput
//                           {...controllerField}
//                           label={subField.label}
//                           type={subField.type || "text"}
//                           fullWidth
//                           required={required}
//                           defaultValue={subField.defaultValue || ""}
//                           size={subField.size || defaultSize}
//                           control={control}
//                           inputProps={{
//                             className: "text-center",
//                             ...register(subField.name),
//                           }}
//                           error={!!errors[subField.name]}
//                           helperText={errors[subField.name]?.message}
//                           onChange={(e) => {
//                             controllerField.onChange(e);
//                             setValue(subField.name, e.target.value);
//                           }}
//                           // Add focus and blur handlers for subfields
//                           onFocus={(e) => {
//                             // console.log(`Subfield ${subField.name} focused`);
//                             if (subField.onFocus) {
//                               subField.onFocus(e);
//                             }
//                             if (onFieldFocus) {
//                               onFieldFocus(subField.name, e);
//                             }
//                           }}
//                           onBlur={(e) => {
//                             // console.log(`Subfield ${subField.name} blurred`);
//                             if (subField.onBlur) {
//                               subField.onBlur(e);
//                             }
//                             if (onFieldBlur) {
//                               onFieldBlur(subField.name, e);
//                             }
//                           }}
//                         />
//                       )}
//                     />
//                   </Grid>
//                 ))}
//               </Grid>
//             </Box>
//           );
//         }
//         return (
//           <Box
//             sx={{
//               ...styles.textFieldContainer,
//               width: field.width || "100%",
//               display: field.display !== false ? "block" : "none",
//             }}
//             key={field.name}
//           >
//             <Controller
//               name={field.name}
//               control={control}
//               rules={field.rules}
//               render={({ field: controllerField }) => (
//                 <FormInput
//                   {...controllerField}
//                   label={field.label}
//                   type={field.type || "text"}
//                   options={field.options || []}
//                   control={control}
//                   defaultValue={field.defaultValue || ""}
//                   formType="redStarForm"
//                   fullWidth
//                   required={required}
//                   size={field.size || defaultSize}
//                   multiline={field.name === "address"}
//                   rows={field.name === "address" ? 4 : undefined}
//                   inputProps={{
//                     className: "text-center",
//                     ...register(field.name, {}),
//                     disabled: field.disabled,
//                     readOnly: field.readOnly,
//                     onClick:
//                       field.name === "google_map_location"
//                         ? onFieldClick
//                         : undefined,
//                   }}
//                   error={!!errors[field.name]}
//                   helperText={errors[field.name]?.message}
//                   onChange={(e) => {
//                     controllerField.onChange(e);
//                     setValue(field.name, e.target.value);
//                   }}
//                   // Add focus and blur event handlers
//                   onFocus={(e) => {
//                     // console.log(`Field ${field.name} focused`);
//                     if (field.onFocus) {
//                       field.onFocus(e);
//                     }
//                     if (onFieldFocus) {
//                       onFieldFocus(field.name, e);
//                     }
//                   }}
//                   onBlur={(e) => {
//                     // console.log(`Field ${field.name} blurred`);
//                     if (field.onBlur) {
//                       field.onBlur(e);
//                     }
//                     if (onFieldBlur) {
//                       onFieldBlur(field.name, e);
//                     }
//                   }}
//                 />
//               )}
//             />
//           </Box>
//         );
//       })}
//     </>
//   );
// };
// export default ReusableFormFields;

import { Box, Grid, Autocomplete, TextField } from "@mui/material";
import React from "react";
import { Controller } from "react-hook-form";
import { StyledTextField, styles } from "../components/formStyles";
import FormInput from "./commonForm";

const ReusableFormFields = ({
  inputFields,
  control,
  errors,
  register,
  setValue,
  required = false,
  defaultSize = "small",
  onFieldClick,
  onFieldFocus,
  onFieldBlur,
}) => {
  const renderSearchableSelect = (field, controllerField) => {
    return (
      <Autocomplete
        {...controllerField}
        options={field.options || []}
        getOptionLabel={(option) => {
          if (React.isValidElement(option?.label)) {
            return "";
          }

          if (typeof option === "string") {
            return option;
          }

          if (typeof option === "object" && option !== null) {
            return (
              option.label || option.name || option.title || option.text || ""
            );
          }

          return String(option || "");
        }}
        getOptionDisabled={(option) => option?.isDisabled || false}
        value={
          field.options?.find(
            (opt) => (opt.value || opt) === controllerField.value
          ) || null
        }
        onChange={(event, newValue) => {
          const value = newValue ? newValue.value || newValue : "";
          controllerField.onChange(value);
          setValue(field.name, value);
          if (field.onChange) {
            const syntheticEvent = {
              target: {
                name: field.name,
                value: value,
              },
              currentTarget: {
                name: field.name,
                value: value,
              },
            };
            field.onChange(syntheticEvent, newValue);
          }
        }}
        renderOption={(props, option) => {
          if (React.isValidElement(option?.label)) {
            return (
              <li {...props} key={option?.value || option?.id || Math.random()}>
                {option.label}
              </li>
            );
          }

          let displayLabel = "";
          if (typeof option === "string") {
            displayLabel = option;
          } else if (typeof option === "object" && option !== null) {
            displayLabel =
              option.label || option.name || option.title || option.text || "";
          } else {
            displayLabel = String(option || "");
          }

          return (
            <li
              {...props}
              key={option?.value || option?.id || option || Math.random()}
            >
              {displayLabel}
            </li>
          );
        }}
        renderInput={(params) => (
          <StyledTextField
            {...params}
            label={
              required ? (
                <>
                  {field.label}
                  <span style={{ color: "red" }}> *</span>
                </>
              ) : (
                field.label
              )
            }
            placeholder={field.placeholder}
            size={field.size || defaultSize}
            fullWidth
            error={!!errors[field.name]}
            helperText={errors[field.name]?.message}
            InputProps={{
              ...params.InputProps,
              className: "form-input w-100",
              sx: {
                width: "100%",
              },
            }}
            FormHelperTextProps={{
              sx: { color: "black" },
            }}
            onFocus={(e) => {
              if (field.onFocus) field.onFocus(e);
              if (onFieldFocus) onFieldFocus(field.name, e);
            }}
            onBlur={(e) => {
              if (field.onBlur) field.onBlur(e);
              if (onFieldBlur) onFieldBlur(field.name, e);
            }}
          />
        )}
        filterOptions={(options, { inputValue }) => {
          return options.filter((option) => {
            if (option?.isDisabled) {
              return true;
            }

            if (React.isValidElement(option?.label)) {
              return true;
            }

            let searchableText = "";
            if (typeof option === "string") {
              searchableText = option;
            } else if (typeof option === "object" && option !== null) {
              searchableText =
                option.label ||
                option.name ||
                option.title ||
                option.text ||
                "";
            } else {
              searchableText = String(option || "");
            }

            const inputStr = String(inputValue || "");
            return searchableText
              .toLowerCase()
              .includes(inputStr.toLowerCase());
          });
        }}
        freeSolo={field.freeSolo || false}
        multiple={field.multiple || false}
        disabled={field.disabled}
        readOnly={field.readOnly}
        placeholder={field.placeholder}
        noOptionsText={field.noOptionsText || "No options"}
        clearOnEscape={field.clearOnEscape !== false}
        fullWidth
      />
    );
  };

  return (
    <>
      {inputFields.map((field) => {
        if (field.type === "group") {
          return (
            <Box
              sx={{
                ...styles.textFieldContainer,
                width: field.width || "100%",
                display: field.display !== false ? "block" : "none",
              }}
              key={field.name}
            >
              <Grid
                container
                spacing={2}
                sx={{ display: "flex", alignItems: "center" }}
              >
                {field.fields.map((subField) => (
                  <Grid item xs={6} key={subField.name}>
                    <Controller
                      name={subField.name}
                      control={control}
                      render={({ field: controllerField }) => {
                        // Handle searchable select for subfields
                        if (subField.type === "searchable-select") {
                          return renderSearchableSelect(
                            subField,
                            controllerField
                          );
                        }

                        return (
                          <FormInput
                            {...controllerField}
                            label={subField.label}
                            type={subField.type || "text"}
                            fullWidth
                            required={required}
                            defaultValue={subField.defaultValue || ""}
                            size={subField.size || defaultSize}
                            control={control}
                            inputProps={{
                              className: "text-center",
                              ...register(subField.name),
                            }}
                            error={!!errors[subField.name]}
                            helperText={errors[subField.name]?.message}
                            onChange={(e) => {
                              controllerField.onChange(e);
                              setValue(subField.name, e.target.value);
                            }}
                            onFocus={(e) => {
                              if (subField.onFocus) {
                                subField.onFocus(e);
                              }
                              if (onFieldFocus) {
                                onFieldFocus(subField.name, e);
                              }
                            }}
                            onBlur={(e) => {
                              if (subField.onBlur) {
                                subField.onBlur(e);
                              }
                              if (onFieldBlur) {
                                onFieldBlur(subField.name, e);
                              }
                            }}
                          />
                        );
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
          );
        }

        return (
          <Box
            sx={{
              ...styles.textFieldContainer,
              width: field.width || "100%",
              display: field.display !== false ? "block" : "none",
            }}
            key={field.name}
          >
            <Controller
              name={field.name}
              control={control}
              rules={field.rules}
              render={({ field: controllerField }) => {
                // Handle searchable select for main fields
                if (field.type === "searchable-select") {
                  return renderSearchableSelect(field, controllerField);
                }

                return (
                  <FormInput
                    {...controllerField}
                    label={field.label}
                    type={field.type || "text"}
                    options={field.options || []}
                    control={control}
                    defaultValue={field.defaultValue || ""}
                    formType="redStarForm"
                    fullWidth
                    required={required}
                    size={field.size || defaultSize}
                    multiline={field.name === "address"}
                    rows={field.name === "address" ? 4 : undefined}
                    inputProps={{
                      className: "text-center",
                      ...register(field.name, {}),
                      disabled: field.disabled,
                      readOnly: field.readOnly,
                      onClick:
                        field.name === "google_map_location"
                          ? onFieldClick
                          : undefined,
                    }}
                    error={!!errors[field.name]}
                    helperText={errors[field.name]?.message}
                    onChange={(e) => {
                      controllerField.onChange(e);
                      setValue(field.name, e.target.value);
                    }}
                    onFocus={(e) => {
                      if (field.onFocus) {
                        field.onFocus(e);
                      }
                      if (onFieldFocus) {
                        onFieldFocus(field.name, e);
                      }
                    }}
                    onBlur={(e) => {
                      if (field.onBlur) {
                        field.onBlur(e);
                      }
                      if (onFieldBlur) {
                        onFieldBlur(field.name, e);
                      }
                    }}
                  />
                );
              }}
            />
          </Box>
        );
      })}
    </>
  );
};

export default ReusableFormFields;
